import Vue from 'vue';
import Router from 'vue-router';

import index from '../components/index';
import product from '../components/product';
import service from '../components/service';
import aboutus from '../components/aboutus';
import contactus from '../components/contactus';
import team from '../components/team';
import partner from '../components/partner';
import customer from '../components/customer';
import category from '../components/category';
import emails from '../components/emails';
import adminlogin from '../components/admin/login.vue';
import adminOrders from '../components/admin/orders.vue';
Vue.use(Router);

var router =  new Router({
    mode: 'history',
    routes: [{
        path: '/',
        component: index
    },{
        path: '/product',
        component: product
    },{
        path: '/service',
        component: service
    },{
        path: '/aboutus',
        component: aboutus
    },{
        path: '/contactus',
        component: contactus
    },{
        path: '/team',
        component: team
    },{
        path: '/partner',
        component: partner
    },{
        path: '/customer',
        component: customer
    },{
        path: '/category',
        component: category
    },{
        path: '/emails',
        component: emails
    },{
        path: '/admin',
        component: adminlogin
    },{
        path: '/admin/orders',
        component: adminOrders
    }]
});

router.beforeEach((to, from, next) => {
    $(window).scrollTop(0);
    if($("#navbarCollapse").css("display") == "block"){
        $("#menuButton").click();
    }
    next()
    
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js